/**
 * Rotulos e regras da meia inscricao, num lugar so.
 *
 * As idades sao as da API (lib/faixaEtaria.js) e valem na **data do evento**,
 * nao na da inscricao. Quem escolhe e o proprio inscrito; a conferencia e
 * humana, na portaria — por isso a faixa tambem aparece na tela de check-in.
 */
export const FAIXAS = [
  { valor: 'INTEIRA', rotulo: 'Inteira', plural: 'inteiras', regra: '11 anos ou mais' },
  { valor: 'MEIA', rotulo: 'Meia', plural: 'meias', regra: 'de 7 a 10 anos' },
  { valor: 'ISENTA', rotulo: 'Isenta', plural: 'isentas', regra: 'até 6 anos' }
]

const POR_VALOR = FAIXAS.reduce((m, f) => ({ ...m, [f.valor]: f }), {})

/** Faixa desconhecida cai em Inteira, como o fator na API. */
export function faixaDe(valor) {
  return POR_VALOR[valor] || POR_VALOR.INTEIRA
}

export function rotuloDaFaixa(valor) {
  return faixaDe(valor).rotulo
}
